/**
 * Helper functions related to Tagular tagging and events.
 * Beam Library: https://github.com/RedVentures/beam
 *
 */

/**
 * Reload the Beam library.
 *
 */
function reloadBeam() {
	// eslint-disable-next-line no-undef
	cohesion('ready', function () {
		_Beam.reload(); // eslint-disable-line no-undef
	});
}

/**
 * Get element-related tags.
 *
 * @param {boolean} isCTA        Whether the element is an element-cta or not. If true, sends ElementClicked, otherwise ElementViewed.
 * @param {Object}  eventPayload Properties to send in the event (Supports: location, type, position, name, outcome and text)
 * @param {boolean} retAsString  Whether the tags should be returned as a space-delimited string instead of an object.
 */
function addElementTags(isCTA, eventPayload, retAsString = true) {
	const elementTags = {
		'data-tag-event': isCTA ? 'elementClick' : 'elementView',
		'data-tag-element-type': eventPayload.elementType,
		'data-tag-action-outcome': eventPayload.actionOutcome,
		'data-tag-name': eventPayload.name,
		'data-tag-position': eventPayload.position,
		'data-tag-text': eventPayload.text,
		'data-tag-location': eventPayload.location ?? 'CONTENT',
		'data-tag-correlation-id': eventPayload.correlationId,
	};
	return retAsString ? transformObjectToString(elementTags) : elementTags;
}

/**
 * Encode Tagular tags.
 *
 * @param {*} key   Name of the attribute.
 * @param {*} value Value of the attribute.
 */
function encodeDataTag(key, value = null) {
	return value !== null ? `${key}="${value}"` : '';
}

/**
 * Transform object to space-separated string value.
 *
 * @param {Object} obj Object to be transformed.
 */
function transformObjectToString(obj = {}) {
	return Object.keys(obj)
		.map((key) => {
			return encodeDataTag(key, obj[key]);
		})
		.join(' ');
}

export { reloadBeam, addElementTags };
